import { render, staticRenderFns } from "./UserHandler.vue?vue&type=template&id=18c96a98&"
import script from "./UserHandler.vue?vue&type=script&lang=js&"
export * from "./UserHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports